define('views/review',[
  "globals",
  "backbone",
  "ext/bootstrap/dropselect",
  "content"
], function (globals, Backbone) {
  "use strict";

  return Backbone.View.extend({
    events: {
      "click .topic-status": "submit"
    },

    initialize: function () {
      _.bindAll(this, "render");

      this.dropselect = this.$el.dropselect({
        allowMultiple: false,
        buttonSelectedClass: ""
      })[0];

      this.model.on("change:status", this.render);
      this.model.on("change:status", this.updateTocStatus);

      this.model.once("request", this.render);
      this.model.on("update", this.render);
    },

    getActive: function (status) {
      return this.$("li [data-status = '" + status + "']" )
    },

    render: function (model) {
      var status = model.get("status");

      this.$(".js-review-label").text(status);

      if (this.dropselect) {
        this.dropselect
            .deselect(this.$("[role = menuitem]"))
            .select(this.getActive(status));
      }

      return this.updateButtonStatus(status);
    },

    updateButtonStatus: function (status) {
      this.$(".btn").attr("data-status", status);
      return this;
    },

    submit: function (e) {
      this.model.save({
        status: $(e.currentTarget).data("status")
      });

      e.preventDefault();
    },

    updateTocStatus: function (model) {
      globals.toc.updateTocStatus(model.get("status"));
    }
  });
});

